import React, {Component} from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Modal from 'react-modal';
import Modal_Empresa from './empresa_modal';
import { Link } from 'react-router-dom';
import firebase from 'firebase';
import store from '../../store';
import Alert from 'react-s-alert';
import copyright from '../../img/copyright-gray.png';
import {sendLog} from '../../util'

const database = firebase.database();

const customStyles = {
	content : {
	  top                   : '50%',
	  left                  : '50%',
	  right                 : 'auto',
	  bottom                : 'auto',
	  transform             : 'translate(-50%, -50%)',
	  width                 : '450px',
	  height: '550px',	 
	  
	}
  };


class Empresa extends Component{


	constructor(props){
		
		super(props);
		this.state={
			
			empresas:[],
			isActive:false,
			keyRow:'',
			codigo_activacion:'',
			codigo_empresa:'',
			correo:'',
			estado:'',
			razon_social:'',
			representante:'',	
			telefono_empresa:'',
			template:false,
			checkAdmin:false
		}
		
		this.empresaRef=database.ref().child('Empresa');
		this.handleKeyPressNumeros=this.handleKeyPressNumeros.bind(this);
		this.ocultarMenu=this.ocultarMenu.bind(this);
		this.handleClickAlerta=this.handleClickAlerta.bind(this);
		this.handleClickClose=this.handleClickClose.bind(this);
		
		 
		this.AlertaContenido = ({
		  id,
		  classNames,
		  styles,
		  message,
		  customFields,
		  handleClose,
		}) => {
		const handleConfirm = () => {
			
			this.updateRow();		
			Alert.close(id);
			this.setState({
				template:false
			})
		}
			return (
			<div className={classNames} id={id} style={styles}>
			  <div className='s-alert-box-inner'>
					{message}
			  </div>
			  <br/>
			  <br/>
			  <button className="customButton btn btn-success btn-alerts btn-m" onClick={handleConfirm.bind(this)}>Confirmar</button>
			  <button className="customButton btn btn-default btn-alerts btn-m-r" onClick={this.handleClickClose}>Cancelar</button>
			  <span className='s-alert-close' onClick={handleClose}></span>
			</div>
			);
		}
		
	}
	
	handleClickClose(){		
		Alert.closeAll();
	}

	
	
	componentWillMount(){
		Modal.setAppElement('body');
	}

	
	componentDidMount() {
		this.empresaRef.on('value', this.gotData, this.errData);
		this.checkSAdmin();
	}

	checkSAdmin = () => {
		let id = firebase.auth().currentUser.uid;
		firebase.database().ref("superAdmin").once("value").then(rows => {
			rows.forEach( element => {
				let data = element.val();
				data.key = element.key;
				if (data.key === id) {
					this.setState({checkAdmin:true})
				}
			})
		})
	}
	
	handleKeyPressNumeros(e){
	
		let tecla=e.which;		
		let patron =/^[0-9]+$/;
		let tecla_final = String.fromCharCode(tecla);
		
		let rs=patron.test(tecla_final);
		
		if(!rs){
			e.preventDefault();		
		}
	
	}
	
	
	handleClickAlerta(event){
		this.setState({
			template:true
			
		})
		const customerName = 'Acacya';
		Alert.success('¿Deseas confirmar los cambios?', {
		  position: 'top-right',
		  timeout:'none',		  
		  customFields: {
			customerName: customerName
		  }
		});
		
		event.preventDefault();
	}
	
	
	gotData = (data) => {
		  let newEmpresa = []
		  if(data.val()!==null){
		  const empresadata = data.val();
		  const keys = Object.keys(empresadata);

		  for (let i = 0; i < keys.length; i++) {
			const k = keys[i];
		

			
			newEmpresa.push({
			  key:k,
			  codigo_activacion:empresadata[k].codigo_activacion,
			  codigo_empresa:empresadata[k].codigo_empresa,
			  correo:empresadata[k].correo,
			  estado:empresadata[k].estado,
			  razon_social:empresadata[k].razon_social,
			  representante:empresadata[k].representante,	
			  telefono_empresa:empresadata[k].telefono_empresa
			});
		  }
		  this.setState({empresas: newEmpresa});
		  }
		}
		errData = (err) => {
	  console.log(err);
	}
	
	handleClick = (rowKey) => {
	  
		this.setState({
		   keyRow:rowKey.key,
		   codigo_activacion:rowKey.codigo_activacion,
		   codigo_empresa:rowKey.codigo_empresa,
		   correo:rowKey.correo,
		   estado:rowKey.estado,
		   razon_social:rowKey.razon_social,
		   representante:rowKey.representante,
		   telefono_empresa:rowKey.telefono_empresa
		   
		});
	  
		this.toggleModalUpdate();
	}
	
	
	
	toggleModalUpdate=()=>{
		
		this.setState({
			
			isActive:!this.state.isActive
		})		
	}
	
	updateRow=()=>{
		
		let nodoHijo=this.keyRow.value;
		
		
		
		
		
		this.empresaRef.child(nodoHijo).update({
		   
		   codigo_empresa:this.empresaNombre.value,
		   correo:this.correoEmpresa.value,
		   estado:this.estadoEmpresa.value,
		   razon_social:this.razon_socialEmpresa.value,
		   representante:this.representanteEmpresa.value,
		   telefono_empresa:this.telefonoEmpresa.value
			
		});
		
	
		
		Alert.success('Datos actualizados correctamente', {
				effect: 'genie',
				position: 'bottom-right',
				timeout:2000			
		});
		sendLog({ tipo: 'empresa_editada', informacion_extra: {empresa: nodoHijo}});
		this.toggleModalUpdate();
		
	}
	
	generateBtnEditar(cell,row) {
		 
		return  <button className="btn btn-success btn-sm" onClick={() => {this.handleClick(row)}} >Editar</button>;
	}
	generateBtnEmpleados(cell,row){
		
		
		let url='/empresa_empleados/'+row.key+'/'+row.codigo_empresa;
		
		return <Link to={url} className="btn btn-info btn-sm">Ver Empleados</Link>;
		
	}
 
	ocultarMenu(){
		
		store.dispatch({
			
			type: 'STATE_MOSTRAR',
			mostrar:'noMostrar'
		})
		
	}
 
	
	render(){
		let {checkAdmin} = this.state;

		return(
		
			<div className="Empresa container" onClick={this.ocultarMenu}>
			
			{this.state.template ? <Alert  timeout='none' contentTemplate={this.AlertaContenido} />:<Alert stack={{limit: 3}} html={true} />}
			
			  <Modal_Empresa/>
			  
			
			  <BootstrapTable data={ this.state.empresas }
				 ref='table'			 
				 pagination={ true }
				 search={ true }
				 hover
				 >
				 <TableHeaderColumn dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
				 <TableHeaderColumn dataField='codigo_empresa' dataSort={true}>Empresa</TableHeaderColumn>
				 <TableHeaderColumn dataField='correo' dataSort={true}>Correo</TableHeaderColumn>
				 <TableHeaderColumn dataField='razon_social'>Razon Social</TableHeaderColumn>
				 <TableHeaderColumn dataField='representante'>Representante</TableHeaderColumn>
				 <TableHeaderColumn dataField='estado' >Estado</TableHeaderColumn>
				 
				 {/* <TableHeaderColumn dataField='ver' dataAlign='center' dataFormat={ this.generateBtnEmpleados.bind(this) }>Ver Empleados</TableHeaderColumn> */}
				 {checkAdmin &&
				 	<TableHeaderColumn dataField='edit' dataAlign='center' dataFormat={ this.generateBtnEditar.bind(this) }>Editar</TableHeaderColumn>
				 }
			  </BootstrapTable>
				
							
			  <Modal isOpen={this.state.isActive} onRequestClose={this.toggleModalUpdate}  style={customStyles}>
						
						<form method="POST" action="" onSubmit={this.handleClickAlerta}>

							<h3>Modificar Empresa</h3>
							<hr/>
							<input type="hidden" ref={input => {this.keyRow=input;}} value={this.state.keyRow}/>
							   <div className="form-group">
									<label htmlFor="nombre" >Empresa:</label>
									<input type="text" className="form-control" name="nombre" 
										ref={input => {this.empresaNombre=input;}}
										placeholder="Nombre" autocomplete="off" required
										defaultValue={this.state.codigo_empresa}
									/>
								</div>
								
								<div className="form-group">
									<label htmlFor="edad" >Razón Social:</label>
									<input type="text" className="form-control" name="edad" 
										ref={input => {this.razon_socialEmpresa=input;}}
										placeholder="Edad"  autocomplete="off" required
										
										defaultValue={this.state.razon_social}
									/>
								</div>
								
								
								
								<div className="form-group">
									<label  htmlFor="telefono" >Telefono:</label>
									<input type="text" className="form-control" name="telefono"
										ref={input => {this.telefonoEmpresa=input;}}
										placeholder="Telefono" required autocomplete="off"
									    defaultValue={this.state.telefono_empresa}
										onKeyPress={this.handleKeyPressNumeros}
										maxLength="8" minLength="8"
									/>
								</div>
								
								<div className="form-group">
									<label  htmlFor="correo" >Correo:</label>
									<input type="text" className="form-control" name="correo"
										ref={input => {this.correoEmpresa=input;}}
										placeholder="Correo" required autocomplete="off"
									defaultValue={this.state.correo}
									/>
								</div>
								
								<div className="form-group">
									<label htmlFor="representante" >Representante:</label>
									<input type="text" className="form-control" name="representante" 
										ref={input => {this.representanteEmpresa=input;}}	
										placeholder="Representante" required autocomplete="off"
			
									defaultValue={this.state.representante}
									/>
								</div>
								
								<div className="form-group row ">
									<div className="col-md-4">
										<label htmlFor="estado" >Estado:</label>
										<select className="form-control"
											ref={input => {this.estadoEmpresa=input;}} name="estado"
											defaultValue={this.state.estado}
										>
											<option>Activo</option>
											<option>Inactivo</option>
										</select>
									</div>
								</div>
								

								
							<hr/>
							<button className="btn btn-primary buttons" type="submit" >Guardar</button>
						</form>
							<button className="btn btn-default buttons btnmargin" onClick={this.toggleModalUpdate}>Cerrar</button>
					</Modal> 
			
				<footer class="footer-pg mt-auto py-3" style={{width:'100%', position:'fixed'}}>
					<div class="container">
						<div class="row">
							<div className="col-md-4 col-sm-4">
							</div>
							<div class="col-sm">
								<img src={copyright}/>
							</div>
						</div>
					</div>
				</footer>
			</div>
				
		
		);
		
		
	}
	
	
}
export default Empresa;


// WEBPACK FOOTER //
// ./src/Components/Empresa/Empresa.jsx